import React from 'react';
import PropTypes from 'prop-types';

export function FrontSection(props) {
  return <div className={props.className} onClick={props.onClick} />;
}

FrontSection.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * callback function to trgger on click
   */
  onClick: PropTypes.func,
};

FrontSection.defaultProps = {
  className: '',
};
